import { render } from "./ServiceCreation.vue?vue&type=template&id=aaae80fc&scoped=true"
import script from "./ServiceCreation.vue?vue&type=script&lang=js"
export * from "./ServiceCreation.vue?vue&type=script&lang=js"

import "./ServiceCreation.vue?vue&type=style&index=0&id=aaae80fc&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaae80fc"]])

export default __exports__